import { motion } from "framer-motion";
import { MaskedReveal } from "@/components/MaskedReveal";

const CHAPTERS = [
  {
    n: "01",
    title: "Pay as you use",
    body: "No rigid monthly locks. Top up points and spend them only when you're here — an hour of focus, a room for an hour, a flat white between meetings.",
  },
  {
    n: "02",
    title: "One currency, everything",
    body: "Points are the language of the room. Use them for F&B, on-demand and long-term desks, meeting rooms and the lounge. Simple, flexible, yours.",
  },
  {
    n: "03",
    title: "A community that gives back",
    body: "Host an event for fellow members and earn points in return. The more you bring to the room, the more the room gives back to you.",
  },
];

export const Manifesto = () => {
  return (
    <section id="manifesto" className="px-6 py-24 sm:px-10 sm:py-32 lg:py-40">
      <div className="mx-auto max-w-[1400px]">
        <div className="mb-20 max-w-2xl">
          <span className="font-body text-xs font-semibold uppercase tracking-[0.28em] text-terracotta">
            The concept
          </span>
          <MaskedReveal
            as="h2"
            className="mt-6 font-display font-light tracking-tight text-espresso"
            lineClassName="text-4xl leading-[1.02] sm:text-5xl"
            lines={["Co-working, re-measured", "by the moment."]}
          />
        </div>

        <div className="border-t border-espresso/10">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              data-testid={`chapter-${c.n}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-15% 0px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className={`grid gap-6 border-b border-espresso/10 py-14 md:grid-cols-12 md:items-baseline ${
                i % 2 === 1 ? "md:pl-[16%]" : ""
              }`}
            >
              <div className="md:col-span-3">
                <span className="font-display text-7xl font-light leading-none text-oak sm:text-8xl">
                  {c.n}
                </span>
              </div>
              <h3 className="font-display text-3xl font-light tracking-tight text-espresso md:col-span-4">
                {c.title}
              </h3>
              <p className="max-w-md font-body text-base font-light leading-relaxed text-stone md:col-span-5">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
